import Vue from 'vue'
import {
  Swipe,
  SwipeItem,
  Popup,
  List,
  DatetimePicker,
  Picker,
  Toast,
  Icon,
  Dialog,
  Uploader,
  NavBar,
  PullRefresh,
  Overlay,
  Notify,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  Tabbar,
  TabbarItem,
  Image as VanImage,
  Lazyload,
  Loading,
  ImagePreview
} from 'vant'

const uses = [
  Swipe,
  SwipeItem,
  Popup,
  List,
  DatetimePicker,
  Picker,
  Toast,
  Icon,
  Dialog,
  Uploader,
  NavBar,
  PullRefresh,
  Overlay,
  Notify,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  Tabbar,
  TabbarItem,
  VanImage,
  Lazyload,
  Loading,
  ImagePreview
]

uses.forEach(use => {
  Vue.use(use)
})

Vue.use(Lazyload, {
  lazyComponent: true
})
